export default new class SubscribeForm {
    constructor() {
        this.form = 'subscribe';
        this.inValidSelector = '_invalid';
        this.subscribeFormInputSelector = 'subscribe__input';
        this.preLoaderSelector = 'subscribe__preloader';
        this.successSelector = 'subscribe__success';
        this.handlers();
    }

    handlers() {
        const form = document.querySelector(`.${this.form}`);

        if (!form) { return; }

        form.addEventListener('submit', (e) => {

            e.preventDefault();

            setTimeout(()=> {
                this.subForm(form);
            });
        });
    }

    subForm(form) {
        if(form.matches(`.${this.inValidSelector}`)) return;

        const inputs = form.querySelectorAll(`.${this.subscribeFormInputSelector}`);
        const successSelector = form.querySelector(`.${this.successSelector}`);

        $.request('SubscribeForm::onSend', {
            form: form,
            loading: `.${this.preLoaderSelector}`,
            success: function (){
                successSelector.classList.add('subscribe__success_show');

                setTimeout(() => {
                    for (let input of inputs) {
                        input.value = '';
                        input.dispatchEvent(new Event('change', {
                            bubbles: true,
                        }));
                    }
                    successSelector.classList.remove('subscribe__success_show');
                }, 2000);
            }
        });
    }
}();
